import * as config from '../core/config'
import md5 from 'js-md5'
import $ from 'jquery'
import store from '../store'
import * as ele from 'element-ui'

/**
 * Ajax请求：GET
 * @param method
 * @param version
 * @param param
 * @returns {Promise<any>}
 */
export function get (method, version, param) {
  return new Promise((resolve, reject) => {
    ajax('GET', method, version, param, (rr) => {
      // 状态码：200 - 226
      resolve(rr)
    }, rr => {
      rr = handleException(rr)
      if (rr != null) {
        reject(rr)
      }
    })
  })
}

/**
 * Ajax请求：POST
 * @param method
 * @param version
 * @param param
 * @returns {Promise<any>}
 */
export function post (method, version, param) {
  return new Promise((resolve, reject) => {
    ajax('POST', method, version, param, (rr) => {
      // 状态码：200 - 226
      resolve(rr)
    }, rr => {
      rr = handleException(rr)
      if (rr != null) {
        reject(rr)
      }
    })
  })
}

/**
 * RestResult：Rest请求结果：与ipf开发框架对应
 * @param code
 * @param gtid
 * @param message
 * @param data
 * @constructor
 */
export function RestResult (code, gtid, message, data) {
  this.code = code
  this.gtid = gtid
  this.message = message
  this.data = data
}

/**
 * 异常处理
 * @param rr
 * @returns {*}
 */
function handleException (rr) {
  if (!rr || !rr.code || !rr.data) {
    return new RestResult(998, 0, 'Request timeout, please try again later', {detail: 'Request timeout, please try again later'})
  }
  switch (rr.code) {
    case 1001: // 未登录用户
    case 1005: // 未知TOKEN
    case 1006: // TOKEN已过期
    case 1007: // TOKEN不可用
      sso()
      return null
    default:
      return rr
  }
}

/**
 * 单点登录处理
 */
function sso () {
  ele.MessageBox.alert('', {
    message: '登录已过期，请重新登录',
    title: '',
    type: 'warning',
    showClose: false
  }).then(() => {
    // 直接重定向登录页面
    store.dispatch('sso').then(() => {
      // 重新实例化vue-router对象 避免bug
      location.reload()
    })
  })
}

/**
 * jQuery的Ajax请求
 * @param type
 * @param method
 * @param version
 * @param param
 * @param success
 * @param failure
 */
function ajax (type, method, version, param, success, failure) {
  if (param == null) {
    param = {}
  }
  //附加第三方ID
  let extra = config.getLinkId() != null ? {link_id: config.getLinkId()} : config.extra
  let timestamp = new Date().getTime()
  let sign = signRequest(config.getAccessToken(), config.app_key, config.client_lang, config.client_version, JSON.stringify(extra), method, JSON.stringify(param), timestamp, version)
  $.ajax({
    type: type,
    async: true,
    timeout: config.timeout,
    url: config.api_url,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: {param: JSON.stringify(param)},
    dataType: 'json',
    beforeSend: function (request) {
      if (method != null) request.setRequestHeader('method', method)
      if (version != null) request.setRequestHeader('version', version)
      if (config.app_key != null) request.setRequestHeader('app_key', config.app_key)
      if (config.client_version != null) request.setRequestHeader('client_version', config.client_version)
      if (config.client_lang != null) request.setRequestHeader('client_lang', config.client_lang)
      if (extra != null) request.setRequestHeader('extra', JSON.stringify(extra))
      if (timestamp != null) request.setRequestHeader('timestamp', timestamp)
      if (sign != null) request.setRequestHeader('sign', sign)
      if (config.getAccessToken() != null) request.setRequestHeader('access_token', config.getAccessToken())
    },
    cache: false,
    success: function (rr) {
      // 状态码：200 - 226
      if (success != null) {
        success(rr)
      }
    },
    error: function (XMLHttpRequest, status, ex) {
      try {
        let rr = JSON.parse(XMLHttpRequest.responseText)
        if (failure != null) {
          failure(rr)
        }
      } catch (ex) {
        failure(new RestResult(998, 0, 'Request timeout, please try again later', {detail: 'Request timeout, please try again later'}))
      }
    }
  })
}

/* Http请求签名 */
/**
 * 请求签名
 * @param access_token
 * @param app_key
 * @param client_lang
 * @param client_version
 * @param extra
 * @param method
 * @param param
 * @param timestamp
 * @param version
 * @returns {*}
 */
function signRequest (access_token, app_key, client_lang, client_version, extra, method, param, timestamp, version) {
  let str = config.app_secret
  if (access_token != null) {
    str = str + 'access_token' + access_token
  }
  if (app_key != null) {
    str = str + 'app_key' + app_key
  }
  if (client_lang != null) {
    str = str + 'client_lang' + client_lang
  }
  if (client_version != null) {
    str = str + 'client_version' + client_version
  }
  if (extra != null) {
    str = str + 'extra' + extra
  }
  if (method != null) {
    str = str + 'method' + method
  }
  if (param != null) {
    str = str + 'param' + param
  }
  if (timestamp != null) {
    str = str + 'timestamp' + timestamp
  }
  if (version != null) {
    str = str + 'version' + version
  }
  str = str + config.app_secret
  return md5(str).toUpperCase()
}

